/** Shared product positioning copy (operating profile, not personality test). */

export const PRODUCT_NAME = 'FounderDNA';

export const LANDING = {
  title: 'Your founder operating profile',
  description:
    'In 3 minutes, see how you lead, decide, and execute under pressure. Get a practical playbook for this week, saved privately on your device.',
  metaDescription:
    'Get your founder operating profile in minutes. Learn how you tend to lead, decide, and execute, plus a weekly playbook you can forward to a co-founder or advisor.',
  disclaimer: '15 questions · 6 operating modes · Saved on this device · Informational only',
};

export const REVEAL = {
  finalEyebrow: 'Full report unlocked',
  finalTagline:
    'Your week plan, stress patterns, meeting scripts, and a PDF you can forward to a co-founder or advisor.',
  openProfileCta: 'Open your operating profile',
  skipCta: 'Skip to full report',
};

export const RESULTS = {
  heroSubcopy:
    'Your default operating modes as a founder. Built to share with a co-founder or advisor.',
  deliverableLead:
    'Forward-ready: export a PDF, email your report, or share your link with a co-founder.',
  teamIntro:
    'See which founder modes complement yours when building a team. Side-by-side profile compare is next.',
};

export const COMPARE = {
  title: 'Compare with a co-founder',
  description:
    'Your full operating profile is free. Send your link so they can take the assessment. Side-by-side compatibility view is coming soon.',
  copyLinkCta: 'Copy invite link',
  waitlistCta: 'Notify me when compare launches',
  waitlistSubject: 'Co-founder compare waitlist',
  waitlistBody:
    'Please notify me when FounderDNA side-by-side co-founder compare is available.\n',
  comingSoon: 'Coming soon',
};

export const SHARE = {
  title: 'Share your operating profile',
  cardLabel: 'Operating profile',
  footer:
    'Built to forward to a co-founder or advisor. Side-by-side compare coming soon.',
  takeQuizLine: 'Take the free assessment at myfounderdna.com',
};

export const EMAIL = {
  subjectPrefix: 'FounderDNA operating profile',
};

export const buildEmailSubject = ({ typeCode, primaryTitle }) => {
  const code = typeCode ? `[${typeCode}] ` : '';
  const title = primaryTitle || 'Your profile';
  return `${EMAIL.subjectPrefix}: ${code}${title}`;
};
